<template>
  <div class="person-block">
    <div v-show="!edit" class="passport-block">
      <div class="passport-block">
        <h2>Passport</h2>
      </div>
      <div class="passport-block-item">
        <h4>Passport Number:</h4>
        <p>{{ person.passport ? `${person.passport.slice(0, -3)}***` : "" }}</p>
      </div>

      <div class="passport-block-item">
        <h4>Date of issue:</h4>
        <p>{{ person.issuedate !== "--20" ? person.issuedate : "" }}</p>
      </div>

      <div class="passport-block-item">
        <h4>Date of expiry:</h4>
        <p>{{ person.expiredate !== "--20" ? person.expiredate : "" }}</p>
      </div>

      <div class="passport-block-item">
        <h4>Nationality:</h4>
        <p>{{ person.nationality }}</p>
      </div>
      <div class="nationality-wrong-box" v-show="nationalityIncorrect">
        <div class="close-box" @click="onClickMyNationalityIncorrect">X</div>
        <span
          >If your nationality is incorrect or you have dual nationality and
          intend on travelling on a different passport to the one highlighted,
          please alert us to this by clicking on the submit button. If your
          nationality is different to what is highlighted, it could affect
          immigration and visa requirements, therefore one of our consultants
          will call you shortly to discuss.
        </span>
        <div class="nationality-wrong-btn-box">
          <button
            class="nationality-btn-wrong nationality-btn-wrong-submit"
            @click="() => onClickSubmitMyNationalityChange(person)"
          >
            <span>Submit</span>
            <i class="material-icons vtd-icon-2 vtd-ml-3"></i>
          </button>
        </div>
      </div>

      <div class="passport-block-item">
        <h4>Issuing authority:</h4>
        <p>{{ person.issauth }}</p>
      </div>

      <div class="passport-block-item">
        <h4>Place of birth:</h4>
        <p>{{ person.pob }}</p>
      </div>

      <div v-if="person.passport">
        <div class="delete-btn-container">
          <b-button
            variant="outline-primary"
            v-show="!nationalityIncorrect"
            @click="onClickMyNationalityIncorrect"
            class="nationality-incorrect-btn"
          >
            <span>Click here if nationality is incorrect</span>
            <i class="material-icons vtd-icon-2 ml-3">info</i>
          </b-button>
          <b-button
            variant="outline-danger"
            @click="deleteConfirm = !deleteConfirm"
            class="passport-delete-btn"
          >
            <span>Delete</span><i class="material-icons vtd-icon-2 ml-3"></i>
          </b-button>
        </div>
      </div>

      <div v-if="!person.passport">
        <div class="nationality-btn-container">
          <button class="nationality-btn-add" @click="onClickEditToggle">
            <span>Add</span>
            <i class="material-icons vtd-icon-2 ml-3"></i>
          </button>
        </div>
      </div>
    </div>

    <b-modal v-model="deleteConfirm" hide-footer>
      <div class="d-block text-center">
        <h3>Are you sure you want to delete passport?</h3>
      </div>
      <b-button
        class="mt-3"
        variant="outline-danger"
        block
        @click="onDeletePassport"
      >
        Yes
      </b-button>
      <b-button
        class="mt-2"
        variant="outline-warning"
        block
        @click="deleteConfirm = !deleteConfirm"
      >
        No
      </b-button>
    </b-modal>

    <div v-show="edit">
      <b-form
        class="person-form passport-form-add"
        @submit.stop.prevent="onSubmit"
      >
        <div class="passport-form-head">
          <p>Passport</p>
        </div>
        <b-row>
          <b-col>
            <b-form-group label="Passport Number:" class="vtd-form-group">
              <b-form-input
                v-model.trim="$v.form.passport.$model"
                type="text"
                class="vtd-form-control vtd-form-control-lg"
                :state="validateState('passport')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group
              label="Date of issue:"
              class="vtd-form-group passport-select-group"
            >
              <b-form-select
                v-model.trim="$v.form.issuedateDay.$model"
                :options="daysSelect()"
                :state="validateState('issuedateDay')"
              />
              <b-form-select
                v-model.trim="$v.form.issuedateMonth.$model"
                :options="monthsSelect()"
                :state="validateState('issuedateMonth')"
              />
              <b-form-select
                v-model.trim="$v.form.issuedateYear.$model"
                :options="yearsSelect()"
                :state="validateState('issuedateYear')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group
              label="Date of expiry:"
              class="vtd-form-group passport-select-group"
            >
              <b-form-select
                v-model.trim="$v.form.expiredateDay.$model"
                :options="daysSelect()"
                :state="validateState('expiredateDay')"
              />
              <b-form-select
                v-model.trim="$v.form.expiredateMonth.$model"
                :options="monthsSelect()"
                :state="validateState('expiredateMonth')"
              />
              <b-form-select
                v-model.trim="$v.form.expiredateYear.$model"
                :options="yearsSelect()"
                :state="validateState('expiredateYear')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label="Nationality:" class="vtd-form-group">
              <b-form-select
                v-model.trim="$v.form.nationalityCode.$model"
                :options="countriesOptions"
                :state="validateState('nationalityCode')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label="Issuing authority:" class="vtd-form-group">
              <b-form-input
                v-model.trim="$v.form.issauth.$model"
                type="text"
                class="vtd-form-control vtd-form-control-lg"
                :state="validateState('issauth')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label="Place of birth:" class="vtd-form-group">
              <b-form-input
                v-model.trim="$v.form.pob.$model"
                type="text"
                class="vtd-form-control vtd-form-control-lg"
                :state="validateState('pob')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <div class="passport-btn-container">
              <b-button
                class="passport-btn-cancel"
                squared
                variant="primary"
                @click="onClickEditToggle"
              >
                <span>Cancel</span>
                <i class="material-icons vtd-icon-2 vtd-ml-3"></i>
              </b-button>
              <b-button
                type="submit"
                class="vtd-btn vtd-btn-success passport-btn-save"
              >
                <span>Save</span>
                <i class="material-icons vtd-icon-2 vtd-ml-3"></i>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import dayjs from '@/lib/dayjs';
import { mapActions } from "vuex";
import countries from "@/lib/countries";

export default {
  props: {
    person: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      edit: false,
      deleteConfirm: false,
      nationalityIncorrect: false,
      form: {
        passport: "",
        issuedateYear: null,
        issuedateMonth: null,
        issuedateDay: null,
        expiredateYear: null,
        expiredateMonth: null,
        expiredateDay: null,
        nationalityCode: null,
        issauth: null,
        pob: null,
      },
    };
  },
  validations: {
    form: {
      passport: { required },
      issuedateYear: { required },
      issuedateMonth: { required },
      issuedateDay: { required },
      expiredateYear: { required },
      expiredateMonth: { required },
      expiredateDay: { required },
      nationalityCode: { required },
      issauth: { required },
      pob: { required },
    },
  },
  computed: {
    dateOfBirthView() {
      return dayjs(this.person.dob, "DDMMYYYY").format("DD-MM-YYYY");
    },
    countriesOptions() {
      return countries.getOptions();
    },
  },
  mounted() {
    // Append class to bootstrap div in select form group
    const selectFormGroup = document.querySelectorAll(".passport-select-group");
    selectFormGroup.forEach((item) =>
      item
        .getElementsByTagName("div")[0]
        .classList.add("passport-select-group-2")
    );
  },
  methods: {
    async onClickSubmitMyNationalityChange(person) {
      await this.nationalityChange(person);
      this.nationalityIncorrect = false;
    },
    onClickMyNationalityIncorrect() {
      this.nationalityIncorrect = !this.nationalityIncorrect;
    },
    onClickEditToggle() {
      this.edit = !this.edit;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    ...mapActions({
      updatePerson: "profile/updateProfilePersonAction",
      deletePersonPassport: "profile/profileDeletePassportAction",
      nationalityChange: "profile/nationalityChangeAction",
    }),
    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      const data = {
        passport: this.form.passport,
        nationalityCode: this.form.nationalityCode,
        issauth: this.form.issauth,
        pob: this.form.pob,
        nationality: countries.getNameByCode(this.form.nationalityCode),
        issuedate: dayjs()
          .year(this.form.issuedateYear)
          .month(this.form.issuedateMonth - 1)
          .date(this.form.issuedateDay)
          .format("DDMMYY"),
        expiredate: dayjs()
          .year(this.form.expiredateYear)
          .month(this.form.expiredateMonth - 1)
          .date(this.form.expiredateDay)
          .format("DDMMYY"),
      };
      await this.updatePerson({ person: this.person, values: data });
      this.edit = false;
    },
    onDeletePassport() {
      this.deleteConfirm = false;
      this.deletePersonPassport(this.person);
    },
    yearsSelect() {
      const currentYear = new Date().getFullYear();
      const maxYear = currentYear + 11;
      const years = [];
      let startYear = currentYear - 11;
      while (startYear <= maxYear) {
        years.push(startYear++);
      }
      return years;
    },
    daysSelect() {
      const days = [];
      for (let i = 1; i < 32; i++) {
        days.push(i);
      }
      return days;
    },
    monthsSelect() {
      const months = [];
      for (let i = 1; i < 13; i++) {
        months.push(i);
      }
      return months;
    },
  },
};
</script>

<style lang="scss">
@import "./styles.scss";

.nationality-incorrect-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  @media only screen and (min-width: 992px) {
    width: auto;
    margin-bottom: 0;
  }
}

.passport-delete-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media only screen and (min-width: 992px) {
    width: auto;
  }
}
</style>
